/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import { GetApp as DownloadIcon, Close as DeleteIcon } from "@material-ui/icons";
import { useState } from "react";
import { CircularProgress, IconButton } from "@material-ui/core";

const AttachmentItem = ({ classes, attachment, editable, handleDownload, handleDelete, disabled }) => {
	const [downloading, setDownloading] = useState(false);

	const _handleDownload = async () => {
		setDownloading(true);
		await handleDownload();
		setDownloading(false);
	};

	return (
		<div className={classes.attachmentItem}>
			<span title={attachment.fileName}>{attachment.fileName}</span>
			{editable && (
				<IconButton onClick={handleDelete} disabled={disabled} title="Remove">
					<DeleteIcon />
				</IconButton>
			)}
			{!editable && !downloading && (
				<IconButton onClick={_handleDownload} disabled={disabled || downloading} title="Download">
					<DownloadIcon />
				</IconButton>
			)}
			{downloading && <CircularProgress color="inherit" size={28} />}
		</div>
	);
};

export default React.memo(AttachmentItem);
